import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Instagram, Music2, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
import Reveal, { RevealDivider } from './Reveal';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-luxury-black text-luxury-champagne py-20 relative">
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
      <div className="section-padding relative z-10">
        <Reveal className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-3xl font-display mb-6">
              PACIFIC <span className="text-luxury-gold">78</span>
            </h3>
            <p className="text-base text-luxury-champagne/70 mb-6 font-body">{t('hero.subtitle')}</p>
            <div className="flex gap-4">
              <motion.a
                whileHover={{ scale: 1.1 }}
                href="https://www.instagram.com/pacificvelizy78"
                target="_blank"
                rel="noopener noreferrer"
                className="text-2xl hover:text-luxury-gold transition-colors duration-300"
              >
                <Instagram size={34} />
              </motion.a>
              <motion.a
                whileHover={{ scale: 1.1 }}
                href="https://www.tiktok.com/@pacific.78"
                target="_blank"
                rel="noopener noreferrer"
                className="text-2xl hover:text-luxury-gold transition-colors duration-300"
              >
                <Music2 size={34} />
              </motion.a>
            </div>
          </div>

          <div>
            <h4 className="text-xl font-display mb-6 text-luxury-champagne">{t('nav.menu')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-base text-luxury-champagne/70 hover:text-luxury-gold transition-colors duration-300 font-body">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-base text-luxury-champagne/70 hover:text-luxury-gold transition-colors duration-300 font-body">
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link to="/menu" className="text-base text-luxury-champagne/70 hover:text-luxury-gold transition-colors duration-300 font-body">
                  {t('nav.menu')}
                </Link>
              </li>
              <li>
                <Link to="/location" className="text-base text-luxury-champagne/70 hover:text-luxury-gold transition-colors duration-300 font-body">
                  {t('nav.location')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xl font-display mb-6 text-luxury-champagne">{t('nav.contact')}</h4>
            <div className="space-y-4 text-base text-luxury-champagne/70 font-body">
              <p className="flex items-start gap-2">
                <MapPin className="mt-1 flex-shrink-0" size={29} />
                <span>
                  1 rue André Citroën<br />
                  78140 Velizy Villacoublay
                </span>
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal>
          <div className="luxury-divider my-12" />
        </Reveal>

        <Reveal className="text-center">
          <p className="text-luxury-champagne/50 text-sm font-body tracking-wide">
            &copy; 2024 Pacific 78 • {t('info.open7days')}
          </p>
          <div className="text-luxury-champagne/50 text-sm font-body tracking-wide mt-2">
            <Link
              to="/legal"
              className="hover:text-luxury-gold transition-colors duration-300"
            >
              {t('nav.legal')}
            </Link>
            <span className="mx-2">•</span>
            <Link
              to="/privacy"
              className="hover:text-luxury-gold transition-colors duration-300"
            >
              {t('nav.privacy')}
            </Link>
            <span className="mx-2">•</span>
            <a
              href="https://pro.ody.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-luxury-gold transition-colors duration-300"
            >
              {t('info.madeBy')}
            </a>
          </div>
        </Reveal>
      </div>
    </footer>
  );
};

export default Footer;